




































import Vue from 'vue'
export default Vue.extend({
  name: "RelationshipField",
  props: {
    field: {
      type: Object,
      default: () => {
        return {} as FormField
      }
    },
    relatable: {
      type: Array as () => Array<{_id:string}>,
      default: () =>  {
        return [] as {_id: string}[]
      }
    }
  },
  data() {
    return {
      searchText: "",
      value: [] as string[]
    }
  },
  computed: {
    filtered():any[] {
      let filtered = this.sorted.filter(item => {
        return this.value.indexOf(item._id) == -1
      })
      if (this.searchText) {
        filtered = filtered.filter(item => JSON.stringify(item).toLowerCase().indexOf(this.searchText.toLowerCase()) > -1)
      }
      return filtered
    },

    selected():any {
      const selected = this.value.map(value => { 
        const name = this.getItem(value) ? this.getItem(value).name : value
        return {
        _id: value, 
        name 
        }
      })

      return this.sort(selected, ["name"])
    },

    sorted():any {
      return this.sort(this.relatable, ["name"])
    }
  },
  methods: {
    deselectItem(id) {
      this.value.splice(this.value.indexOf(id), 1)
    },
    getItem(id):any {
      return this.relatable.find(item => item._id === id)
    },
    selectItem(id) {
      this.value.push(id)
    },
    sort(items, fields) {
      return this.$schema.sort(items, fields)
    }
  },

  created() {
    this.value = this.field.value || []
  },

  watch: {
    value(value) {
      this.$emit('change', value)
    }
  }
})
